import useCategoriesSelect from 'modules/categories/hooks/use-categories-select';
import useReorderProducts from 'modules/products/hooks/use-reorder-products';
import {ProductProps, translatedProductProps} from 'modules/products/types';
import React from 'react';
import {useNavigate} from 'react-router-dom';
import Creation from 'shared/layout/creation';
import {Operators} from 'shared/migration-components/filter-list/types';
import useFormInputs from 'shared/migration-components/form/util';
import useProjection from 'shared/migration-hooks/use-projection';

const ReorderProducts: React.FC = () => {
  const projection = useProjection('products', [
    'id',
    'name',
    'category.name',
    'subCategory.name',
    'priceMode',
    'price',
    'sizes',
    'active',
  ]);
  const {getSelect} = useFormInputs<ProductProps>();
  const {data, isLoading} = useCategoriesSelect();

  const navigate = useNavigate();

  const handleViewOrder = (data: any) => {
    projection.filter.onChange({
      'category.name': {operator: Operators.Equals, value: data.categoryId},
    });
    projection.orderBy?.onChange({field: data.field, order: 1});
    navigate(-1);

    return data;
  };

  return (
    <Creation<ProductProps>
      titleBar={{title: 'Ordenação dos produtos no aplicativo'}}
      {...{handleSubmit: handleViewOrder}}
      inputs={[
        getSelect({
          name: 'categoryId',
          data,
          isLoading,
        }),
        getSelect({
          name: 'field' as any,
          label: 'Ordenar por',
          data: [
            {label: 'Nome', value: 'name'},
            {label: 'Data de cadastro', value: 'createdAt'},
            {label: 'Preço', value: 'minPrice'},
            {label: 'Customizado', value: 'orderIndex'},
          ],
        }),
      ]}
      onSubmit={useReorderProducts}
      extraButtons={(data) => [
        {title: 'Mostrar ordenação', onClick: () => handleViewOrder(data)},
      ]}
      translationKey={translatedProductProps}
    />
  );
};

export default ReorderProducts;
